export default "__VITE_ASSET__QUI0tp59__"